import { render, staticRenderFns } from "./productHighlight.vue?vue&type=template&id=6c240045&"
import script from "./productHighlight.vue?vue&type=script&lang=js&"
export * from "./productHighlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports